import { motion } from "framer-motion";

const sections = [
  {
    title: "1. Toplanan Bilgiler",
    content: `
Web sitemizi ziyaret ettiğinizde veya bizimle iletişime geçtiğinizde bazı kişisel veriler toplanabilir.

Bu veriler aşağıdakileri içerebilir:
• Ad ve soyad
• Telefon numarası
• E-posta adresi
• Mesaj içerikleri
• Randevu bilgileri

Ayrıca web sitesinin kullanımı sırasında bazı teknik veriler otomatik olarak kaydedilebilir:
• IP adresi
• Tarayıcı türü
• Cihaz bilgisi
• Ziyaret edilen sayfalar ve kullanım süresi
• Çerez (cookie) verileri
`,
  },
  {
    title: "2. Bilgilerin Kullanımı",
    content: `
Toplanan kişisel veriler aşağıdaki amaçlarla kullanılabilir:
• Danışmanlık hizmetlerine ilişkin iletişim süreçlerinin yürütülmesi
• Randevu taleplerinin alınması ve planlanması
• Kullanıcı taleplerinin değerlendirilmesi
• Web sitesi deneyiminin geliştirilmesi
• Yasal yükümlülüklerin yerine getirilmesi
`,
  },
  {
    title: "3. Bilgi Paylaşımı",
    content: `
Kişisel verileriniz üçüncü kişilerle ticari amaçlarla paylaşılmaz.

Ancak aşağıdaki durumlarda paylaşım yapılabilir:
• Yasal yükümlülüklerin yerine getirilmesi amacıyla yetkili kamu kurum ve kuruluşları ile
• Web sitesi altyapısı, hosting veya teknik destek hizmeti sağlayan iş ortakları ile
• Kullanıcının açık rızasının bulunduğu durumlarda

Bu paylaşımlar yalnızca gerekli olduğu ölçüde ve ilgili mevzuata uygun şekilde gerçekleştirilir.
`,
  },
  {
    title: "4. Veri Güvenliği",
    content: `
Kişisel verilerinizin korunması amacıyla gerekli teknik ve idari güvenlik önlemleri alınmaktadır. Yetkisiz erişim, veri kaybı, veri sızıntısı veya kötüye kullanım risklerine karşı uygun güvenlik sistemleri uygulanmaktadır.
`,
  },
  {
    title: "5. Çerezler (Cookies)",
    content: `
Web sitemiz kullanıcı deneyimini geliştirmek amacıyla çerezler kullanabilir. Çerezler, web sitesinin daha verimli çalışmasını sağlamak ve kullanıcı tercihlerini hatırlamak amacıyla kullanılmaktadır.

Tarayıcı ayarlarınızı değiştirerek çerezleri kontrol edebilir veya devre dışı bırakabilirsiniz.

Web sitesinde kullanıcı deneyimini geliştirmek ve site kullanımını analiz etmek amacıyla çerezler ve benzeri teknolojiler ile anonim analiz araçları kullanılabilir.
`,
  },
  {
    title: "6. Veri Saklama Süresi",
    content: `
Kişisel verileriniz, ilgili mevzuatta belirtilen süreler boyunca veya işleme amacının gerektirdiği süre kadar saklanır. Saklama süresi sona erdiğinde veriler mevzuata uygun şekilde silinir, yok edilir veya anonim hale getirilir.
`,
  },
  {
    title: "7. Kullanıcı Hakları",
    content: `
KVKK kapsamında kişisel verilerinize ilişkin aşağıdaki haklara sahipsiniz:
• Kişisel verilerinize erişme
• Düzeltme talep etme
• Silinmesini talep etme
• İşlenmesine itiraz etme

Haklarınıza ilişkin taleplerinizi aşağıdaki iletişim adresi üzerinden iletebilirsiniz.
`,
  },
  {
    title: "8. Politika Güncellemeleri",
    content: `
Bu gizlilik politikası gerekli görüldüğü durumlarda güncellenebilir. Güncellenmiş politika web sitesinde yayımlandığı tarihten itibaren geçerli kabul edilir.
`,
  },
  {
    title: "9. İletişim",
    content: `
Gizlilik politikası ile ilgili sorularınız veya talepleriniz için aşağıdaki iletişim adresi üzerinden bizimle iletişime geçebilirsiniz.

E-posta: info@aysunseremet.com
`,
  },
];

export default function PrivacyPolicy() {
  return (
    <section className="bg-gray-50 py-24 px-6 lg:px-12">
      <motion.div
        className="max-w-4xl mx-auto text-center space-y-6"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        <h1 className="text-4xl font-bold text-gray-900">
          Gizlilik Politikası
        </h1>
        <p className="text-gray-600 text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed">
          Bu gizlilik politikası, web sitemizi ziyaret ettiğinizde kişisel
          verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu
          açıklamak amacıyla hazırlanmıştır. Web sitemizi ziyaret ederek bu
          gizlilik politikasında belirtilen uygulamalar hakkında
          bilgilendirilmiş olursunuz.
        </p>
      </motion.div>

      <div className="mt-16 max-w-3xl mx-auto space-y-6">
        {sections.map((section, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{
              duration: 0.8,
              delay: index * 0.1,
              ease: "easeInOut",
            }}
          >
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {section.title}
            </h2>

            {section.content.split("\n").map((line, i) =>
              line.trim() ? (
                <p
                  key={i}
                  className="text-gray-700 leading-relaxed mb-2 whitespace-pre-line"
                >
                  {line}
                </p>
              ) : null
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}